import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setOverlayVisible, startVolume } from '../../../store/stream/stream-slice';
import { AppDispatch } from '../../../store/store';
import { establishConnection } from '../../../store/stream/stream-operations';
import { Link } from 'react-router-dom'; // Импортируем Link для навигации
import './AllowVolume.scss';
import { setAgree, setPrivacy } from '../../../store/chat/chat-slice';
import { trackAnalyticsEvent } from '../../../utils/analytics';


const AllowVolume: React.FC= () => {
  const dispatch: AppDispatch = useDispatch();
  const [isCookieBannerVisible, setCookieBannerVisible] = useState(true);
  const [isButtonEnabled, setButtonEnabled] = useState(false);
  const textContainerRef = useRef<HTMLDivElement>(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);
  const [isSmallScreenH, setIsSmallScreenH] = useState(window.innerHeight < 700);
  useEffect(() => {
    trackAnalyticsEvent(process.env.REACT_APP_API_URL, 'disclaimer_shown');
  }, []);
  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const handleResize = () => setIsSmallScreenH(window.innerHeight < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleAcceptVolume = async () => {
    try {

      // await navigator.mediaDevices.getUserMedia({ audio: true });
      setCookieBannerVisible(false);
      dispatch(setOverlayVisible(false));
      dispatch(establishConnection());
      dispatch(startVolume(true));
      dispatch(setAgree(true))
      trackAnalyticsEvent(process.env.REACT_APP_API_URL, 'disclaimer_accepted');
    } catch (error) {

    }
  };

  const handleScroll = () => {
    const container = textContainerRef.current;
    if (container) {
      const isScrolledToBottom =
        Math.abs(container.scrollHeight - container.scrollTop - container.clientHeight) < 1;
      setButtonEnabled(isScrolledToBottom);
    }
  };

  const handlePrivacy = () => {
    dispatch(setPrivacy(true));
    trackAnalyticsEvent(process.env.REACT_APP_API_URL, 'privacy_opened');
  }

  return (
    <>
      {isCookieBannerVisible && (
        <div className="cookie-banner" id="cookie-banner">
          <div
            className="cookie-text"
            ref={textContainerRef}
            onScroll={handleScroll}
          >
            <p>
              Настоящий ИИ-Аватар и размещенная в нем информация предназначены только для медицинских работников и могут
              быть использованы медицинскими работниками только в образовательных и/или справочно-информационных целях.
            </p>
            <p>
              Настоящий ИИ-Аватар является способом представления информации из массивов опубликованных данных по
              терапии соответствующих заболеваний; клинических рекомендаций; иных официальных документов и/или
              опубликованных источников в визуально доступной форме.
            </p>
            <p>
              Настоящий ИИ-Аватар <span>НЕ ЯВЛЯЕТСЯ МЕДИЦИНСКИМ ИЗДЕЛИЕМ.</span> ИИ-Аватар <span>НЕ ПРЕДНАЗНАЧЕН ДЛЯ ПОСТАНОВКИ ДИАГНОЗОВ, НАЗНАЧЕНИЯ ЛЕЧЕНИЯ КОНКРЕТНЫМ ПАЦИЕНТАМ, ОПРЕДЕЛЕНИЯ ПОРЯДКА ЗАПОЛНЕНИЯ РЕЦЕПТУРНЫХ БЛАНКОВ.</span>
            </p>
            <p>
              Настоящий ИИ-Аватар <span>НЕ</span> предназначен для оказания медицинской помощи либо использования при
              оказании медицинской помощи пациентам, в том числе в клинической и лабораторной диагностике, для
              профилактики и лечения заболеваний.
            </p>
            <p>
              Настоящий ИИ-Аватар не сохраняет или каким-либо иным образом не аккумулирует введённые данные и
              информацию, а все данные приводятся одномоментно в режиме реального времени.
            </p>
            <p>Информация, размещенная на данном веб-сайте, предназначена только для медицинских работников и не может
              быть использована иными лицами, в том числе для замены консультаций со специалистом/врачом.</p>
            <p><span>Вы являетесь медицинским работником и согласны с утверждениями выше?</span></p>
            <p>
              Нажимая «да» Вы также соглашаетесь с <span><a onClick={handlePrivacy}>соглашением об использовании аватара «Артём»</a></span>
            </p>
          </div>
          <div className="buttonCon">
            <button
              id="connect-button"
              onClick={handleAcceptVolume}
            >
              Да
            </button>
            <a className="noLink" href="https://gipotireoz.ru/patient" onClick={() => trackAnalyticsEvent(process.env.REACT_APP_API_URL, 'disclaimer_declined')}>Нет</a></div>

        </div>
      )}
    </>
  );
};

export default AllowVolume;
